export default function debugLog(state = [], action) {
  // if (action.type !== 'LOG') return state;

  return [
    ...state,
    {
      action,
      timestamp: new Date().toISOString(),
    },
  ];
}
